import DocsSiteSource from '@modules/eventStream/enum/DocsSiteSource';
import { useTranslation } from '@rbx/intl';
import React, { FC, MouseEvent, useState } from 'react';
import { useRouter } from 'next/router';
import usePageLogs from '@modules/miscellaneous/common/hooks/usePageLogs';
import LoggedPage from '@modules/eventStream/enum/LoggedPage';
import DynamicallyRouted from '@modules/miscellaneous/common/components/DynamicallyRouted';
import { assistantAbsolutePath } from '../constants/assistantNavConstants';
import useAssistantNavStyles from './AssistantNav.styles';
import AssistantIcon from './AssistantIcon';

const AssistantNavButton: FC<React.PropsWithChildren> = () => {
  const { logEnterEntryPoint } = usePageLogs(LoggedPage.Assistant);
  const router = useRouter();
  const [assistantClicked, setAssistantClicked] = useState(false);
  const {
    classes: { assistantIcon },
  } = useAssistantNavStyles();
  const { translate } = useTranslation();

  const onAssistantNavigate = (e: MouseEvent<HTMLButtonElement>) => {
    if (assistantClicked) return; // avoid dbl clicking + dbl tracking
    setAssistantClicked(true);
    e.preventDefault();
    e.stopPropagation();
    logEnterEntryPoint(DocsSiteSource.DocsHomeAssistantButton);
    router.push(assistantAbsolutePath);
  };

  return (
    // show link for accessibility
    <DynamicallyRouted.Button
      href={assistantAbsolutePath}
      onClick={onAssistantNavigate}
      disabled={assistantClicked}
      size='large'
      variant='outlined'
      color='primary'>
      <AssistantIcon size={18} className={assistantIcon} />
      {translate('Label.AskAssistant') || 'Ask Assistant'}
    </DynamicallyRouted.Button>
  );
};

export default AssistantNavButton;
